import React, { PureComponent } from 'react';
import cn from 'classname';
import './main.less';

import omit from 'lodash/omit';

import { Calendar } from 'react-date-range';
import ClickOutside from 'react-onclickoutside';

class DatePicker extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false
		};

		this.handleClickOutside = this.handleClickOutside.bind(this);

		this.toggle = this.toggle.bind(this);
		this.change = this.change.bind(this);
	}

	handleClickOutside() {
		this.setState({ isOpen: false });
	}

	toggle() {
		if (!this.props.disabled) {
			this.setState((state) => ({ isOpen: !state.isOpen }));
		}
	}

	change(value) {
		this.setState({ isOpen: false }, () => this.props.input.onChange(value));
	}

	render() {
		const { className, disabled, above, isResetAllowed, input, meta, ...props } = omit(this.props, [
			'enableOnClickOutside',
			'disableOnClickOutside'
		]);

		const isOpen = this.state.isOpen;

		return (
			<div className={cn('date-picker--field', disabled && 'disabled', className)}>
				<div
					className={cn('date-picker--field--head', isOpen && 'is-open')}
					onClick={this.toggle}
				>
					<span>{input.value && input.value.format('DD.MM.YYYY')}</span>
				</div>
				{isOpen && (
					<div className={cn({
						'date-picker--field--body-above': !!above,
						'date-picker--field--body-under': !above
					})}>
						<Calendar
							{...props}
							date={input.value}
							onChange={this.change}
						/>
						{isResetAllowed && (
							<button
								className='date-picker--field--reset'
								onClick={() => this.change(null)}
							>
								reset
							</button>
						)}
					</div>
				)}
				{(meta.touched && meta.error) && (
					<div className='date-picker--field--error'>
						{meta.error}
					</div>
				)}
			</div>
		);
	}
}

export default ClickOutside(DatePicker);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/date-picker/main.js